__turbopack_context__.v({
  "shimmer-sweep": "index-module__OsT9tq__shimmer-sweep",
  "shotPreviewMarkdown": "index-module__OsT9tq__shotPreviewMarkdown",
  "skeletonShimmer": "index-module__OsT9tq__skeletonShimmer",
  "timeMaker": "index-module__OsT9tq__timeMaker",
});
